import { useState } from "react";
import ReportsContent from "../ones/ReportsBanner";
import ResearchesContent from "../ones/ResearchBanner";
import EthicsContent from "../ones/EthicsBanner";
import Footer from "../ones/Footer";

export default function ResourcesLanding() {
  const [activeTab, setActiveTab] = useState("reports");

  return (
    <>
      <section
        className="page-hero text-white"
        style={{
          backgroundImage:
            "linear-gradient(120deg, rgba(18,60,140,0.92), rgba(18,60,140,0.62))",
        }}
      >
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-8" data-aos="fade-up">
              <p className="about-tag bg-light text-dark d-inline-flex align-items-center mb-3">
                TEF Knowledge Hub
              </p>
              <h1 className="font-bold display-5 mb-3">Resources</h1>
              <p className="lead mb-0">
                Browse reports, research, and ethics guidance curated to support journalism practice and newsroom growth.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="MainBodySection">
        <div className="container">
          <div className="d-flex justify-content-center gap-5 mt-4 resource-tabs" data-aos="fade-up">
            {["reports", "researches", "ethics"].map((tab) => (
              <div
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`resource-tab ${activeTab === tab ? "active" : ""}`}
              >
                {tab === "ethics"
                  ? "Ethics Guidelines"
                  : tab.charAt(0).toUpperCase() + tab.slice(1)}
              </div>
            ))}
          </div>

          <div className="mt-4" data-aos="fade-up">
            {activeTab === "reports" && <ReportsContent />}
            {activeTab === "researches" && <ResearchesContent />}
            {activeTab === "ethics" && <EthicsContent />}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
